var map = {
	"./+2 MPC(20-06-2026).xlsx": 1580,
	"./JR BIPC(20-06-2026).xlsx": 1581,
	"./JR MPC(20-06-2026).xlsx": 1582,
	"./SR BIPC(20-06-2026).xlsx": 1583,
	"./SR MPC(20-06-2026).xlsx": 1584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1579;